export default __webpack_public_path__ + "static/media/readytoship.d642c47a.svg";